import styles from './styles.module.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouteLink } from 'react-router-dom';
import { generateRoute } from '../../utils/location';
import { ChevronRight } from '@material-ui/icons';
import { AppMarketPageIdentifier } from '../../AppRoutes';

interface CollectionHeaderProps {
  collectionDisplayName?: string;
  carousalName?: string;
  collectionId?: string;
  localeUSA: boolean;
  hideSeeAll?: boolean;
}

export const AppCollectionHeader: React.FC<CollectionHeaderProps> = ({
  collectionDisplayName,
  carousalName,
  collectionId,
  localeUSA,
  hideSeeAll,
}) => {
  const { t } = useTranslation(),
    headerText: string | undefined = localeUSA
      ? collectionDisplayName
      : t('carousels.' + carousalName + '.display_name', collectionDisplayName),
    translatedSeeAll = t('app_collections.see_all');
  let collectionRoute = generateRoute(AppMarketPageIdentifier.Collections, collectionId);
  return (
    <div className={styles.carouselLinkWrapper}>
      <h3 className={styles.carouselHeader}>{headerText}</h3>
      {!hideSeeAll && (
        <RouteLink to={collectionRoute} tabIndex={0} aria-label={translatedSeeAll + headerText}>
          <span
            color="inherit"
            className={styles.carouselLink}           
          >
            {translatedSeeAll}<ChevronRight className={styles.chevronRight}/>
          </span>
        </RouteLink>
      )}
    </div>
  );
};
